import {Injectable} from "@angular/core";
import {AlertController, LoadingController, ToastController} from "ionic-angular";

@Injectable()
export class MsgUtils {

  constructor(public alertCtrl: AlertController, public toastCtrl: ToastController
    , public loadingCtrl: LoadingController) {
  }

  /***
   * Alert
   * @param {string} title         大标题
   * @param {string} subTitle      小标题内容
   */
  alert(title: string, subTitle: string) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: subTitle,
      buttons: ['确定']
    });
    alert.present();
  }

  /***
   * Toast提示
   * @param {string} msg    展示信息
   * @param {string} position  位置（"top", "middle", "bottom"）
   * @param {number} times    悬停时间
   */
  toast(msg: string, position: string, times: number) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: times,
      position: position
    });
    toast.present();
  }

  /***
   * Loading加载动画
   * @param {string} spinner 过渡动画 ("ios", "dots", "bubbles", "circles")
   * @param {string} content 内容
   */
  loading(spinner: string, content: string) {
    let loading = this.loadingCtrl.create({//加载动画
      spinner: spinner,
      content: content
    });
    loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/util/msgutils.ts